import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, PhoneCall, Calendar, Settings, MessageSquare } from 'lucide-react';
export function Sidebar() {
  const navItems = [{
    icon: <PhoneCall size={20} data-id="element-140" />,
    label: 'Follow-up Queue',
    path: '/'
  }, {
    icon: <MessageSquare size={20} data-id="element-141" />,
    label: 'Campaigns',
    path: '/campaigns'
  }, {
    icon: <Calendar size={20} data-id="element-142" />,
    label: 'Calendar',
    path: '/calendar'
  }];
  return <aside className="w-64 bg-slate-900 text-slate-300 flex flex-col h-screen border-r border-slate-800" data-id="element-143">
      <div className="h-16 flex items-center px-6 border-b border-slate-800" data-id="element-144">
        <div className="flex items-center gap-2 text-white font-bold text-xl" data-id="element-145">
          <div className="w-8 h-8 bg-blue-600 rounded-md flex items-center justify-center" data-id="element-146">
            <Home size={18} className="text-white" data-id="element-147" />
          </div>
          <span data-id="element-148">MortgageCRM</span>
        </div>
      </div>

      <div className="flex-1 py-6 overflow-y-auto" data-id="element-149">
        <div className="px-4 mb-2 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-150">
          Menu
        </div>
        <nav className="space-y-1 px-3" data-id="element-151">
          {navItems.map((item, i) => <NavLink key={i} to={item.path} className={({
          isActive
        }) => `flex items-center gap-3 px-3 py-2.5 rounded-md transition-colors ${isActive ? 'bg-blue-600/10 text-blue-400 font-medium' : 'hover:bg-slate-800 hover:text-white'}`} data-id="element-152">
              {item.icon}
              {item.label}
            </NavLink>)}
        </nav>
      </div>

      <div className="p-4 border-t border-slate-800" data-id="element-153">
        <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-md hover:bg-slate-800 hover:text-white transition-colors" data-id="element-154">
          <Settings size={20} data-id="element-155" />
          Settings
        </a>
        <div className="mt-4 flex items-center gap-3 px-3" data-id="element-156">
          <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-sm font-medium text-white" data-id="element-157">
            LO
          </div>
          <div className="flex flex-col" data-id="element-158">
            <span className="text-sm font-medium text-white" data-id="element-159">Loan Officer</span>
            <span className="text-xs text-slate-500" data-id="element-160">NMLS #123456</span>
          </div>
        </div>
      </div>
    </aside>;
}